// extracted by mini-css-extract-plugin
module.exports = {"backButton":"SnoozeModal_backButton__jOsj9","title":"SnoozeModal_title__SV_IH","form":"SnoozeModal_form__KKWkP"};